// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"838dc4d8","71":"57d2cc8b","520":"543f1953"}[chunkId] + ".chunk.js";
};